import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Input } from '@components/core-ui/form-elements/Input';
import { Switch } from '@components/core-ui/form-elements/Switch';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { useAPI } from '@providers/useAPI';
import { useMutation } from '@tanstack/react-query';
import { useModalContext } from '@providers/ModalProvider';
import { FeatureFlagsService } from 'app/API';
import { notifyApiCallError } from 'app/http/notifyApiCallError';
import React, { useState } from 'react';

import { Content } from './styles/Content';
import { TProps } from './types/TProps';

export const CreateNewAttorneyFeatureFlag = ({ onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();
  const { closeModal } = useModalContext();
  const [flag, setFlag] = useState({
    name: '',
    value: false,
  });

  const submitMutation = useMutation({
    mutationFn: () =>
      call(() => FeatureFlagsService.createForAttorneyView({ requestBody: { name: flag.name, value: flag.value } })),
    onSuccess: () => {
      closeModal();
      onSuccess();
    },
    onError: notifyApiCallError,
  });

  const handleSubmit = () => submitMutation.mutate();

  return (
    <ModalWrapper width="370px">
      {submitMutation.isPending ? <AbsoluteSpinner overlay={true} /> : null}
      <ModalTitle>Create new Feature Flag</ModalTitle>
      <Content>
        <div className="input-wrapper">
          <div className="label">Name</div>
          <Input
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFlag({ ...flag, name: e.target.value })}
            label="Name"
            value={flag.name}
          />
        </div>

        <div className="input-wrapper">
          <div className="label">Value</div>
          <Switch className="switch" checked={flag.value} onChange={() => setFlag({ ...flag, value: !flag.value })} />
        </div>

        <div className="buttonGroup">
          <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
          <Button onClick={handleSubmit} disabled={submitMutation.isPending}>
            Save
          </Button>
        </div>
      </Content>
    </ModalWrapper>
  );
};
